/* Layout */
import Layout from '../../views/layout/Layout.vue'

const FeaturedList = () => import(/* webpackChunkName: "featured-list" */ '@/views/featured/list')
const FeaturedDetail = () => import(/* webpackChunkName: "featured-detail" */ '@/views/featured/detail')
const TrendingTopBrandList = () => import(/* webpackChunkName: "trending" */ '@/views/trending/top-brand-list')
const TrendingTopBrandDetail = () => import(/* webpackChunkName: "trending" */ '@/views/trending/top-brand-detail')
const TrendingBrandList = () => import(/* webpackChunkName: "trending" */ '@/views/trending/brand-list')
const TrendingBrandDetail = () => import(/* webpackChunkName: "trending" */ '@/views/trending/brand-detail')
const TrendingSearchDetail = () => import(/* webpackChunkName: "trending" */ '@/views/trending/search-detail')
const TrendingBannerScheduleList = () => import(/* webpackChunkName: "trending" */ '@/views/trending/banner-schedule-list')
const TrendingBannerScheduleDetail = () => import(/* webpackChunkName: "trending" */ '@/views/trending/banner-schedule-detail')

export default [
  {
    path: '/trending',
    component: Layout,
    redirect: 'noredirect',
    name: 'trending',
    alwaysShow: true,
    meta: {
      title: 'trending',
      icon: 'home',
    },
    children: [
      {
        path: 'featured-items',
        component: FeaturedList,
        name: 'featured-items-list',
        meta: {
          title: 'featuredList',
          icon: 'list',
          accessibleName: 'trending',
        },
      },
      {
        path: 'featured-items/edit/type/:type/platform/:platform',
        component: FeaturedDetail,
        props: true,
        name: 'featured-items-edit',
        hidden: true,
        meta: {
          title: 'edit',
          accessibleName: 'trending',
        },
      },
      {
        path: 'top-brand-edit/:slug',
        component: TrendingTopBrandDetail,
        props: true,
        name: 'trending-top-brand-edit',
        hidden: true,
        meta: {
          title: 'topBrandEdit',
          accessibleName: 'trending',
        },
      },
      {
        path: 'top-brand-list',
        component: TrendingTopBrandList,
        name: 'top-brand-list',
        meta: {
          title: 'topBrandList',
          icon: 'list',
          accessibleName: 'trending',
        },
      },
      {
        path: 'brand-edit/:slug',
        component: TrendingBrandDetail,
        props: true,
        name: 'trending-brand-edit',
        hidden: true,
        meta: {
          title: 'brandEdit',
          accessibleName: 'trending',
        },
      },
      {
        path: 'brand-list',
        component: TrendingBrandList,
        name: 'trending-brand-list',
        meta: {
          title: 'brandList',
          icon: 'list',
          accessibleName: 'trending',
        },
      },
      {
        path: 'search-edit',
        component: TrendingSearchDetail,
        name: 'trending-search-edit',
        meta: {
          title: 'searchEdit',
          icon: 'edit',
          accessibleName: 'trending',
        },
      },
      {
        path: 'marketplace-brands',
        component: () => import(/* webpackChunkName: "marketplace-featured-brands" */ '@/views/marketplace/featuredBrands/list'),
        name: 'marketplace-brands-list',
        meta: {
          title: 'marketplaceBrandsList',
          icon: 'list',
          accessibleName: 'trending',
        },
      },
      {
        path: 'marketplace-brands/create',
        component: () => import(/* webpackChunkName: "marketplace-featured-brands" */ '@/views/marketplace/featuredBrands/detail'),
        name: 'marketplace-brands-create',
        hidden: true,
        meta: {
          title: 'create',
          accessibleName: 'trending',
        },
      },
      {
        path: 'marketplace-brands/edit/:id',
        component: () => import(/* webpackChunkName: "marketplace-featured-brands" */ '@/views/marketplace/featuredBrands/detail'),
        props: true,
        hidden: true,
        name: 'marketplace-brands-edit',
        meta: {
          title: 'edit',
          accessibleName: 'trending',
        },
      },
      {
        path: 'banner-schedules',
        component: TrendingBannerScheduleList,
        name: 'banner-schedule-list',
        meta: {
          title: 'bannerScheduleList',
          icon: 'list',
          accessibleName: 'trending',
        },
      },
      {
        path: 'banner-schedules/create',
        component: TrendingBannerScheduleDetail,
        hidden: true,
        name: 'banner-schedule-detail',
        meta: {
          title: 'create',
          accessibleName: 'trending',
        },
      },
      {
        path: 'banner-schedules/edit/:id',
        component: TrendingBannerScheduleDetail,
        props: true,
        hidden: true,
        name: 'banner-schedule-detail',
        meta: {
          title: 'edit',
          accessibleName: 'trending',
        },
      },
    ],
  },
]
